import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { loginRoute } from 'src/app/core/routing/route-names';
import { ActivationGuardBase } from './activation-guard.base';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends ActivationGuardBase {
  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  checkLogin(url: string): boolean {
    if (this.authService.isUserLoggedIn()) {
      return true;
    }


    this.authService.redirectUrl = url;


    this.router.navigate([loginRoute]);
    return false;
  }
}
